import ReportSummaryTopicsPage from './reportSummaryTopics.page';

export default ReportSummaryTopicsPage;
